import * as React from 'react';
import { SVGProps } from 'react';

export const Armchair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.625 25.8438H10.375C8.13795 25.8414 5.99318 24.9517 4.41134 23.3699C2.82951 21.7881 1.93982 19.6433 1.9375 17.4063C1.9375 16.6603 2.23382 15.945 2.76126 15.4175C3.28871 14.8901 4.00408 14.5938 4.75 14.5938C5.49592 14.5938 6.21129 14.8901 6.73874 15.4175C7.26618 15.945 7.5625 16.6603 7.5625 17.4063C7.56316 18.152 7.85969 18.867 8.38699 19.3943C8.9143 19.9216 9.62928 20.2181 10.375 20.2188H21.625C22.3707 20.2181 23.0857 19.9216 23.613 19.3943C24.1403 18.867 24.4368 18.152 24.4375 17.4063C24.4375 16.6603 24.7338 15.945 25.2613 15.4175C25.7887 14.8901 26.5041 14.5938 27.25 14.5938C27.9959 14.5938 28.7113 14.8901 29.2387 15.4175C29.7662 15.945 30.0625 16.6603 30.0625 17.4063C30.0602 19.6433 29.1705 21.7881 27.5887 23.3699C26.0068 24.9517 23.8621 25.8414 21.625 25.8438Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.6875 27.7189L6.9825 25.1301"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3126 27.7189L25.0176 25.1301"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.93 14.9237L24.93 7.46125C24.7938 6.57569 24.345 5.76816 23.665 5.18485C22.9849 4.60154 22.1184 4.28099 21.2225 4.28125H10.78C9.88423 4.28129 9.01808 4.60197 8.33827 5.18526C7.65845 5.76854 7.20988 6.57591 7.07373 7.46125L6.07373 14.9237"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Armchair;
